import React, { createContext, useContext } from "react";
import { useTimeAndAttendanceService } from "../services/TimeAndAttendance.service";

let operationsAllowed = {};
const TimeAndAttendanceFacadeContext = createContext(operationsAllowed);

export const TimeAndAttendanceFacadeProvider = (props: any) => {

  const timeAndAttendanceService = useTimeAndAttendanceService();

  const getShiftDetailsActiveTabIndex = () => {
    return timeAndAttendanceService.getShiftDetailsActiveTabIndex();
  }

  const setShiftDetailsActiveTabIndex = (activeTabIndex: number) => {
    timeAndAttendanceService.setShiftDetailsActiveTabIndex(activeTabIndex);
  }

  operationsAllowed = {
    getShiftDetailsActiveTabIndex,
    setShiftDetailsActiveTabIndex
  };

  return (
    <TimeAndAttendanceFacadeContext.Provider value={operationsAllowed}>
      {props.children}
    </TimeAndAttendanceFacadeContext.Provider>
  );
};

export const useTimeAndAttendanceFacade = () => {
  return useContext(TimeAndAttendanceFacadeContext);
};
